import { render, staticRenderFns } from "./SaleOrderModal.vue?vue&type=template&id=482ae1f4&scoped=true"
import script from "./SaleOrderModal.vue?vue&type=script&lang=js"
export * from "./SaleOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482ae1f4",
  null
  
)

export default component.exports